import { NotificationService } from './../../service/notification.service';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gate-email-status',
  imports: [NgClass,TranslatePipe],
  templateUrl: './email-status.component.html',
  styleUrl: './email-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailStatusComponent {
  @Input() email!: string;
  @Input() emailVerified?: boolean;
  public copied = signal(false);

  private notificationService = inject(NotificationService);

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value);
    this.copied.set(true);
    this.notificationService.showNotification('success', 'notification.emailCopiedToClipboard.title', 'notification.emailCopiedToClipboard.message');
    setTimeout(() => this.copied.set(false), 5000);
  }
}
